/* eslint-disable class-methods-use-this */
import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { ThreeView, View3dGlobal, webcadDefines } from '../../../view3d/webcad';
import { AddCeilingItemLoader } from '../../../view3d/webcad/loader/AddCeilingItemLoader';
import { AddWallItemLoader } from '../../../view3d/webcad/loader/AddWallitemLoader';
import { AddFloorItemLoader } from '../../../view3d/webcad/loader/AddFloorItemLoader';

import * as roomMaterial from '../../../view3d/webcad/material'
import { AddPin } from '../../../view3d/webcad/loader/AddPin';
import { AddSiteItemLoader } from '../../../view3d/webcad/loader/AddSiteItemLoader';
import { MonicaObject } from '../../item';
import MasterItemCollection from '../../collection/MasterItemCollection';
import { ObjectType } from '../../../view3d/webcad/ObjectType';
import { ModelLoadSystem } from '../../../view3d/webcad/WebCad3dModelLoadSystem';
import ItemSearchUtil from '../../util/ItemSearchUtil';
import ItemDetailUtil from '../../util/ItemDetailUtil';

const INITIAL_TAB_ID = 'tab_1';
const TAB_TYPE_ATTRIBUTE = 'data-tabType';
const TAB_TYPE_TEXTURE = 'texture';
const TEXTURE_TAB_SELECTOR = '#dialogTextureAndItemStarts .tabContent1';
const TEXTURE_ITEM_SELECTOR = '#dialogTextureAndItemStarts .textureChangeList li';
const ITEM_ID_ATTRIBUTE = 'data-name';
const ITEM_3D_ID_ATTRIBUTE = 'data-item3did';
const ACTIVE_CLASS = 'is-active';
const EVENT_CLICK = 'click';
const EVENT_SCROLL = 'scroll';
const INSERT_POSITION_END = 'beforeend';
const HIDDEN_DISPLAY = 'none';
const VISIBLE_DISPLAY = '';

/**
 * 3Dーテクスチャ変更
 * 対象：壁、床、天井
 */
export default class TextureAndItemDialogStarts extends Dialog {
  public target: any = undefined;

  public $tree: any = null;

  static saveState: { tabId: string, selectCategory: string } = { tabId: 'tab_2', selectCategory: 'all' };

  static tabId = 'tab_2';

  public itemListHtmlStr = ''; // 画像読み込み高速化のために外に置く

  private isReady:boolean = false;

  private alternativeEndItemList:MasterItemCollection[] = [];

  public initialMaterial:string;

  private selectedEndItem: MasterItemCollection = null;

  private selectedItem3did: string = null;

  private innerWall(obj: THREE.Object3D) {
    return ObjectType.isInnerWall(obj) || ObjectType.isFallingWall(obj);
  }

  private ceiling(obj: THREE.Object3D) {
    return ObjectType.isCeiling_(obj);
  }

  private floor(obj: THREE.Object3D) {
    return ObjectType.isFloor_(obj);
  }

  // 外構判定
  private site(obj: THREE.Object3D) {
    return ObjectType.isSite(obj);
  }

  /**
   * ダイアログを中心へ
   */
  public centerDialog() {
    if (this.isReady) {
      // window-heightに対する、ダイアログ高さ調整
      const h1: number = this.viewObj.querySelector('.dialogBody').getBoundingClientRect().height;

      const dialogFooter = this.viewObj.querySelector('.dialogFooter');

      const h2: number = (dialogFooter) ? this.viewObj.querySelector('.dialogFooter').getBoundingClientRect().height : 0;
      if (window.innerHeight <= (h1 + h2 + 120)) {
        (this.viewObj.querySelector('.dialogBody') as HTMLElement).style.height = `${window.innerHeight - h2 - 120}px`;
      }

      // ダイアログの幅調整
      let maxW: number = 0;
      for (let i: number = 0; i < this.viewObj.children.length; i += 1) {
        const w:number = this.viewObj.children[i].getBoundingClientRect().width;
        if (maxW < w) {
          maxW = Math.ceil(w);
        }
        (this.viewObj.children[i] as HTMLElement).style.display = 'block';
      }
      this.viewObj.style.width = `${maxW}px`;

      // ダイアログの高さ調整
      let boxHeight: number = 0;
      for (let i:number = 0; i < this.viewObj.children.length; i += 1) {
        boxHeight += this.viewObj.children[i].getBoundingClientRect().height;
      }
      this.viewObj.style.height = `${boxHeight}px`;
    }
  }

  buildContent() {
    let dummyID:string = "wallpaper";
    if (this.floor(this.target)) {
      dummyID = "flooring";
    }

    // データがなければ取得しにいく
    if (marietta.webcad.WebCADGlobal.masterManager.getGroupListForId(dummyID)) {
      // リスト生成
      this.buildContentAfterCheck();
    } else {
      let dummyID:string = "wallpaper";
      if (this.floor(this.target)) {
        dummyID = "flooring";
      }

      let changePoint: roomMaterial.ChangePointWall | roomMaterial.ChangePointCeiling | roomMaterial.ChangePointFloor = undefined;
      if (this.innerWall(this.target)) {
        // 壁のテクスチャ変更
        changePoint = new roomMaterial.ChangePointWall(this.target);
        //見積リストのハイライト表示
        marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList(changePoint.get2D(),'wall');
        console.log()

      } else if (this.ceiling(this.target) || ObjectType.isGirder(this.target)) {
        // 天井のテクスチャ変更
        changePoint = new roomMaterial.ChangePointCeiling(this.target);
        //見積リストのハイライト表示
        marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList(changePoint.get2D(),'ceiling');
      } else if (this.floor(this.target)) {
        // 床のテクスチャ変更
        changePoint = new roomMaterial.ChangePointFloor(this.target);
        //見積リストのハイライト表示
        marietta.webcad.WebCADGlobal.quotationItemList.highlightQuotationItemList(changePoint.get2D(),'floor');
      }
      let currentSelection:MasterItemCollection = changePoint.getEndItem();

      //データをサーバから取得
      marietta.webcad.WebCADGlobal.showBusy("商品データ取得中...");
      const p = new Promise((resolve: Function) => {
        if (currentSelection == null) {
          marietta.webcad.WebCADGlobal.masterManager.getSymbolItemsMasterData(dummyID, resolve);
        } else {
          marietta.webcad.WebCADGlobal.masterManager.getGroupItemsMasterData(currentSelection.item_id, resolve);
        }
      });
      p.then((list:any[] = []) => {
        this.alternativeEndItemList = [];
        for (let i:number = 0; i < list.length; i++) {
          let master:MasterItemCollection = new MasterItemCollection(list[i]);
          this.alternativeEndItemList.push(master);
        }
        ItemSearchUtil.moveToFront(this.alternativeEndItemList, currentSelection?.item_id);
        this.buildContentAfterCheck();
        marietta.webcad.WebCADGlobal.hideBusy();
      });
    }

  }

  buildContentAfterCheck() {
    // ダイアログのコンテンツ生成
    const id = 'dialogTextureAndItemStarts';

    let title = '';
    let contents = '<div class="tabWrap">';

    if (!this.site(this.target)) {
      contents += '<input id="tab_1" type="radio" name="tabs" class="tabSwitch">';
      let tab1Name = '';
      if (this.innerWall(this.target)) {
        tab1Name = '<span class="jp">壁紙変更</span><span class="en">Texture</span>';
      } else if (this.ceiling(this.target) || ObjectType.isGirder(this.target)) {
        tab1Name = '<span class="jp">天井材変更</span><span class="en">Texture</span>';
      } else if (this.floor(this.target)) {
        tab1Name = '<span class="jp">床材変更</span><span class="en">Texture</span>';
      }
      contents += `<label class="tabLabel" for="tab_1" data-tabType="texture" data-tabIndex="1">${tab1Name}</label>`;
      contents += '<div class="tabContent tabContent1">';
      contents += ItemSearchUtil.createSearchBoxHtml();
      contents += '<div class="textureChangeList"></div>';
      contents += ItemSearchUtil.createEmptyMessageHtml();
      contents += '</div>';
      contents += '<input id="tab_2" type="radio" name="tabs" class="tabSwitch">';
      contents += '<label class="tabLabel" for="tab_2" data-tabType="item" data-tabIndex="2"><span class="jp">アイテム追加</span><span class="en">Add Item</span></label>';
      contents += '<div class="tabContent tabContent2">';
      contents += '<div class="addItemCategorySelect"></div>';
      contents += '<div class="addItemList"><ul><ul></div>';
      contents += '</div>';
    } else {
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp': title = 'アイテム追加'; break;
        default: title = 'Add Item'; break;
      }
      contents += '<div class="addItemCategorySelect"></div>';
      contents += '<div class="addItemList"><ul><ul></div>';
    }
    contents += '</div>';

    const footer = this.site(this.target) ? '<button id="btnOK"><span class="jp">閉じる</span><span class="en">Close</span></button>' : ItemDetailUtil.APPLY_FOOTER_HTML;

    this.createDialog(id, title, contents, footer);
    if (!this.site(this.target)) this.setTextureSelectEvent();

    document.getElementById('dialogTextureAndItemStarts').classList.add(`${this.site(this.target) ? 'siteMode' : 'notSiteMode'}`);
    this.createTextureList();
    this.createCategoryTree();
    this.setEvent();
    this.setInit();
    this.updateCurrent();

    // イベント設定
    const btn = document.querySelector('#btnOK');
    btn?.addEventListener('click', this.btnEventHandler);
  }

  /**
   * OKボタンがクリックされた
   * パフォーマンスチェッカーの可視性の処理
   * @return void
   * @param e => mouse event
   */
  btnEventHandler = (e: any) => {
    e.preventDefault();
    // パネルを閉じる
    marietta.webcad.WebCADGlobal.removeDialog();
  }

  /*
  * 操作状態の復元
  */
  setInit() {
    // ダイアログ全体はスクロールさせず、一覧だけをスクロールさせる（全体だと iOS でタブの見出しが切り取られる）
    const BODY_OVERFLOW = 'hidden';
    (document.querySelector('#dialogTextureAndItemStarts .dialogBody') as HTMLElement).style.overflowY = BODY_OVERFLOW;
    (document.querySelector('#dialogTextureAndItemStarts .dialogBody .tabWrap') as HTMLElement).style.overflowY = BODY_OVERFLOW;
    if (!this.site(this.target)) {
      (document.getElementById(INITIAL_TAB_ID) as HTMLInputElement).checked = true;
    }
    if (!this.$tree.tree('getNodeById', TextureAndItemDialogStarts.saveState.selectCategory)) TextureAndItemDialogStarts.saveState.selectCategory = 'all';
    this.$tree.tree('getNodeById', TextureAndItemDialogStarts.saveState.selectCategory).element.querySelector('span').click();
    (document.querySelector('#dialogTextureAndItemStarts .addItemCategorySelect') as HTMLElement).style.width = `${String(this.$tree.width() + 10)}px`;
  }

  /**
   * テクスチャリストの生成
   */
  private createTextureList() {
    let changePoint: roomMaterial.ChangePointWall | roomMaterial.ChangePointCeiling | roomMaterial.ChangePointFloor = undefined;
    if (this.innerWall(this.target)) {
      // 壁のテクスチャ変更
      changePoint = new roomMaterial.ChangePointWall(this.target);
    } else if (this.ceiling(this.target) || ObjectType.isGirder(this.target)) {
      // 天井のテクスチャ変更
      changePoint = new roomMaterial.ChangePointCeiling(this.target);
    } else if (this.floor(this.target)) {
      // 床のテクスチャ変更
      changePoint = new roomMaterial.ChangePointFloor(this.target);
    }
    let currentSelection:MasterItemCollection = changePoint.getEndItem();

    let contents = '';
    if ( 0 < this.alternativeEndItemList.length) {
      contents += '<ul>';
      for (let i = 1; i <= this.alternativeEndItemList.length; i += 1) {
        const alt = this.alternativeEndItemList[i - 1];
        const imgPath = alt.hasOwnProperty('item_thumb_path') ? alt.item_thumb_path : '';
        if (currentSelection && currentSelection.item_id === alt.item_id) {
          contents += `<li data-name="${alt.item_id}" class="btnChangeItem is-active" data-itemid="${i}" data-item3did="${alt.symbol_3d_code}" data-itemindex="${i}">`;
        } else {
          contents += `<li data-name="${alt.item_id}" class="btnChangeItem" data-itemid="${i}" data-item3did="${alt.symbol_3d_code}" data-itemindex="${i}" >`;
        }
        contents += `<button id="changeItem${String(i)}">`;
        contents += '<div class="imbBox">';
        contents += `<img class='itemImgThumb' src="${imgPath}"/>`;
        contents += '<div class="currentFrame"></div>';
        contents += '</button>';
        // contents += `<p><span class="jp">${alternatives[i - 1].name}</span><span class="en">${alternatives[i - 1].nameEn}</span></p>`;
        contents += '</div>';
        contents += '</li>';
      }
      contents += '</ul>';
      document.querySelector('#dialogTextureAndItemStarts .tabContent1 .textureChangeList').innerHTML = contents;
    }
  }

  /*
  * 追加アイテムのカテゴリー切り換えボタン
  */
  private createCategoryTree = () => {
    let contents = '<div id="categoryTree"></div>';
    let Json: JSON = null;
    switch (true) {
      case this.floor(this.target): Json = floorItem; break;
      case this.innerWall(this.target): Json = wallItem; break;
      case this.ceiling(this.target): Json = ceilingItem; break;
      case ObjectType.isGirder(this.target): Json = ceilingItem; break;
      case this.site(this.target): Json = exteriorItem; break;
      default: Json = null; break;
    }
    document.querySelector('#dialogTextureAndItemStarts .addItemCategorySelect').innerHTML = contents;
    this.$tree = ($('#categoryTree') as any);
    this.$tree.tree({ // JSONデータのセット
      data: Json,
      autoOpen: true,
    });
  }

  /**
   * アイテムリストの生成
   */
  private createItemList(itemId: string[]) {
    /* if (this.category[category] === 'Pin') {
      new AddPin(this.target);
      this.close();
      return;
    } */
    const dir = View3dGlobal.shared.itemDir;
    // アイテムリストの生成
    itemId.forEach((id) => {
      const data = View3dGlobal.threeView.planmgr.autoData.alternativeId(id);
      if (data) {
        const imgPath = dir + data.item.thumbnail;
        this.itemListHtmlStr += `<li class="btnAddItem" data-itemid=${data.itemId} data-index=${data.index + 1}>`;
        this.itemListHtmlStr += `<button id="addItem${data.index + 1}">`;
        this.itemListHtmlStr += '<div class="imbBox">';
        this.itemListHtmlStr += `<img src="${imgPath}" width="76" height="76" loading="lazy"/>`;
        this.itemListHtmlStr += '</div>';
        this.itemListHtmlStr += '</li>';
      }
    });
  }

  /**
   * イベントの生成
   */
  setEvent() {

    document.querySelectorAll('#dialogTextureAndItemStarts .tabWrap .tabLabel').forEach((elem) => {
      elem.addEventListener('click', (e) => {
        (document.querySelector(`#dialogTextureAndItemStarts #tab_${(e.currentTarget as HTMLElement).getAttribute('data-tabIndex')}`) as HTMLInputElement).checked = true;
        (document.querySelector('#dialogTextureAndItemStarts .addItemCategorySelect') as HTMLElement).style.width = `${String(this.$tree.width() + 10)}px`;
        this.updateFooterForTab((e.currentTarget as HTMLElement).getAttribute(TAB_TYPE_ATTRIBUTE) === TAB_TYPE_TEXTURE);
      });
    });
    document.querySelectorAll(TEXTURE_ITEM_SELECTOR).forEach((elem) => {
      elem.addEventListener(EVENT_CLICK, (e) => {
        this.selectTexture(e.currentTarget as HTMLElement);
      });
    });
    this.$tree.on(
      'tree.click',
      (e) => {
        const { node } = e;
        if (node.id === 'pin') {
          const pin = new AddPin();
          pin.click(this.target);
          this.close();
          return;
        }
        TextureAndItemDialogStarts.saveState.selectCategory = node.id; // 選択状態の保存
        // 既に選択状態ならスキップ
        if (this.$tree.tree('getNodeById', TextureAndItemDialogStarts.saveState.selectCategory)?.element.querySelector('span').classList.contains('listActive')) return;
        // リストを初期化
        document.querySelector('#dialogTextureAndItemStarts .addItemList ul').innerHTML = '';
        this.itemListHtmlStr = '';
        // current表示の更新
        document.getElementById('categoryTree').querySelector('.listActive')?.classList.remove('listActive');
        this.$tree.tree('getNodeById', TextureAndItemDialogStarts.saveState.selectCategory).element.querySelector('span').classList.add('listActive');
        if (node) {
          const searchItemId = (itemObjArr) => {
            if (itemObjArr.itemId && itemObjArr.itemId.length) { // アイテムIDを持っている場合
              this.createItemList(itemObjArr.itemId); // アイテムリストの生成
            }
            if (itemObjArr.children && itemObjArr.children.length) { // 子カテゴリ内の検索
              itemObjArr.children.some((obj) => searchItemId(obj));
            }
          };
          searchItemId(node);
        }
        // リスト生成
        document.querySelector('#dialogTextureAndItemStarts .addItemList ul').innerHTML += this.itemListHtmlStr;
        // イベント生成
        document.querySelectorAll('#dialogTextureAndItemStarts .addItemList .btnAddItem').forEach((elem) => {
          elem.addEventListener('click', (e) => {
            const itemId = (e.currentTarget as HTMLElement).getAttribute('data-itemid');
            const index = (e.currentTarget as HTMLElement).getAttribute('data-index');
            this.close();
            if (this.innerWall(this.target)) {
              // 壁にアイテムを追加
              // eslint-disable-next-line no-new
              new AddWallItemLoader(itemId, index);
            } else if (this.ceiling(this.target) || ObjectType.isGirder(this.target)) {
              // 天井アイテムの追加
              // eslint-disable-next-line no-new
              new AddCeilingItemLoader(itemId, index);
            } else if (this.floor(this.target)) {
              // 床アイテムの追加
              // eslint-disable-next-line no-new
              new AddFloorItemLoader(itemId, index);
            } else if (this.site(this.target)) {
              // 外構アイテムの追加
              // eslint-disable-next-line no-new
              new AddSiteItemLoader(itemId, index);
            }
          });
        });
      },
    );
  }

  /**
   * 壁紙変更等タブの検索・詳細表示・適用ボタンのイベント（ダイアログ生成時に1回だけ登録）
   */
  private setTextureSelectEvent(): void {
    this.viewObj.insertAdjacentHTML(INSERT_POSITION_END, ItemDetailUtil.createHtml(ItemDetailUtil.TEXTURE_FIELDS));
    // リストのスクロールで吹き出しとサムネイルの位置がずれるため閉じる
    this.viewObj.addEventListener(EVENT_SCROLL, () => ItemDetailUtil.hide(this.viewObj), true);
    const textureTab: Element = document.querySelector(TEXTURE_TAB_SELECTOR);
    ItemSearchUtil.bindInput(textureTab, (query: string) => {
      ItemDetailUtil.hide(this.viewObj);
      const matched: Set<string> = ItemSearchUtil.applyToList(textureTab, this.alternativeEndItemList, query);
      // 選択中のアイテムが検索で隠れたら、見えないまま適用されないよう選択を外す
      if (this.selectedEndItem && !matched.has(String(this.selectedEndItem.item_id))) this.clearSelection();
    });
    document.getElementById(ItemDetailUtil.CANCEL_BUTTON_ID).addEventListener(EVENT_CLICK, this.btnEventHandler);
    const applyButton: HTMLElement = document.getElementById(ItemDetailUtil.APPLY_BUTTON_ID);
    ItemDetailUtil.setApplyEnabled(applyButton, false);
    applyButton.addEventListener(EVENT_CLICK, () => {
      if (!this.selectedEndItem) return;
      this.applyTexture(this.selectedEndItem, this.selectedItem3did);
    });
  }

  /**
   * サムネイルの選択と詳細の表示
   */
  private selectTexture(elem: HTMLElement): void {
    const itemId: string = elem.getAttribute(ITEM_ID_ATTRIBUTE);
    const master: MasterItemCollection = this.alternativeEndItemList.find((item) => String(item.item_id) === itemId);
    if (!master) return;
    this.selectedEndItem = master;
    this.selectedItem3did = elem.getAttribute(ITEM_3D_ID_ATTRIBUTE);

    document.querySelectorAll(TEXTURE_ITEM_SELECTOR).forEach((item) => item.classList.remove(ACTIVE_CLASS));
    elem.classList.add(ACTIVE_CLASS);
    ItemDetailUtil.fill(this.viewObj, master);
    ItemDetailUtil.show(this.viewObj, elem);
    ItemDetailUtil.setApplyEnabled(document.getElementById(ItemDetailUtil.APPLY_BUTTON_ID), true);
  }

  /**
   * 選択の解除
   */
  private clearSelection(): void {
    document.querySelectorAll(TEXTURE_ITEM_SELECTOR).forEach((item) => item.classList.remove(ACTIVE_CLASS));
    this.selectedEndItem = null;
    this.selectedItem3did = null;
    ItemDetailUtil.hide(this.viewObj);
    ItemDetailUtil.setApplyEnabled(document.getElementById(ItemDetailUtil.APPLY_BUTTON_ID), false);
  }

  /**
   * 選択したテクスチャを反映して閉じる
   */
  private applyTexture(master: MasterItemCollection, item3did: string): void {
    //選択解除
    ThreeView.get().wallEffect.unselect();

    let changePoint: roomMaterial.ChangePointWall | roomMaterial.ChangePointCeiling | roomMaterial.ChangePointFloor = undefined;
    if (this.innerWall(this.target)) {
      // 壁のテクスチャ変更
      changePoint = new roomMaterial.ChangePointWall(this.target);
    } else if (this.ceiling(this.target) || ObjectType.isGirder(this.target)) {
      // 天井のテクスチャ変更
      changePoint = new roomMaterial.ChangePointCeiling(this.target);
    } else if (this.floor(this.target)) {
      // 床のテクスチャ変更
      changePoint = new roomMaterial.ChangePointFloor(this.target);
    }
    // エンドアイテムの設定
    changePoint.setToEndItem(master);

    changePoint.setMaterialByName(item3did);

    // 3D読込直し 3D内観ビューのカメラ情報を保持
    marietta.view3d.webcad.View3dGlobal.shared.saveCameraState();
    // 屋根形状の変更を行った時に外観カメラ位置を保持しておき
    marietta.view3d.webcad.View3dGlobal.shared.keepCameraState = true;
    new ModelLoadSystem().request3D();

    //見積リストの更新
    marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();

    this.close();
  }

  /**
   * アイテム追加タブでは適用ボタンを隠し、詳細を閉じる
   */
  private updateFooterForTab(isTextureTab: boolean): void {
    ItemDetailUtil.hide(this.viewObj);
    const applyButton: HTMLElement = document.getElementById(ItemDetailUtil.APPLY_BUTTON_ID);
    if (applyButton) applyButton.style.display = isTextureTab ? VISIBLE_DISPLAY : HIDDEN_DISPLAY;
    // タブを行き来しても選択は残るため、戻ったときに選択の有無へ合わせ直す
    ItemDetailUtil.setApplyEnabled(applyButton, this.selectedEndItem !== null);
  }

  /*
  * カレント表示の追加
  */
  updateCurrent() {
    // const element = document.querySelector(`#dialogTextureAndItemStarts .textureChangeList [data-name='${this.target.material.map.userData.title}']`);
    const element = document.querySelector(`#dialogTextureAndItemStarts .textureChangeList [data-name='${this.initialMaterial}']`);
    if (element) element.closest('li').classList.add('is-active');
  }

  /**
   * ダイアログを閉じる
   */
  closeEvent() {
    // 操作状態の保存
    const tabId = !this.site(this.target) ? document.querySelector('#dialogTextureAndItemStarts .tabSwitch:checked').id : TextureAndItemDialogStarts.tabId;
    // const categoryIndex = Number((document.querySelector('#dialogTextureAndItemStarts .addItemCategorySelect select') as HTMLInputElement).value);
    // const scrollV = document.querySelector('#dialogTextureAndItemStarts .dialogBody').scrollTop;
    TextureAndItemDialogStarts.tabId = tabId;

    this.viewObj.remove();
    if (this.showHeaderCloseButton) {
      this.viewObj.querySelector('.dialogCloseBtn').removeEventListener('click', this.close);
    }

    // コールバックのお掃除関数
    if (this.globalCleanUpFunc) this.globalCleanUpFunc();

    if (this.prevDialog) {
      marietta.webcad.WebCADGlobal.currentDialog = this.prevDialog;
      if (marietta.webcad.WebCADGlobal.currentDialog.hasModal)marietta.webcad.WebCADGlobal.currentDialog.handleModal();
    }

    // 3Dの場合
    if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === '3D') {
      marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d.reset();
    }

    // モーダルのデザインを元に戻す
    document.getElementById('modalBg').style.backgroundColor = '#000';
    document.getElementById('modalBg').style.opacity = '.6';
    document.getElementById('modalBg').style.pointerEvents = 'auto';
  }
}
